// extracted by mini-css-extract-plugin
module.exports = {"row":"FaqsLayout_row__m9fju","title":"FaqsLayout_title___atpN","question":"FaqsLayout_question__ignwZ","content":"FaqsLayout_content__f2jDK"};